import _ from 'lodash';
import React from 'react';
import { navigateAction } from 'fluxible-router';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import WineSkuStore, { defaultSorter } from '../../stores/WineSkuStore';
import InventorySearchResults from '../../components/InventorySearchResults';
import Breadcrumbs from '../../components/Breadcrumbs';
import styles from './index.sass';

class UniversalSearchContainer extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func,
    trackEvent: React.PropTypes.func,
    buildURLForRoute: React.PropTypes.func
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  handleOnClickBreadcrumbsFilter(filter) {
    // Remove it
    let filters = _.filter(this.props.searchState.filters, (f) => {
      return !_.isEqual(f, filter);
    });
    let sorter = this.props.searchState.sorter;
    if(!sorter || _.isEqual(sorter, defaultSorter)) {
      sorter = null;
    }

    this.context.executeAction(navigateAction, {
      url: this.context.buildURLForRoute('universalSearch', {
        filters: filters,
        sorter: sorter
      })
    });
  }

  render() {
    let { currentRoute, searchState } = this.props;
    let breadcrumbsProps = {
      className: styles.breadcrumbs,
      links: [
        {routeName: 'home'},
        {routeName: 'universalSearch', text: 'Search'}
      ],
      onClickFilter: this.handleOnClickBreadcrumbsFilter.bind(this)
    };

    if(searchState.filters.length) {
      breadcrumbsProps.filters = _.filter(searchState.filters, (filter) => {
        switch(filter.type) {
          case 'text':
          case 'min_price_in_cents':
          case 'max_price_in_cents':
          case 'store_id':
            return false;
          default:
            return true;
        }
      });
    }

    let inventorySearchResultsProps = {
      currentRoute,
      ...searchState,
      loading: searchState.loading //|| !this.props.isNavigateComplete
    };

    return (
      <section className={styles.container}>
        <Breadcrumbs {...breadcrumbsProps} />
        <InventorySearchResults {...inventorySearchResultsProps} />
      </section>
    );
  }
}

UniversalSearchContainer = connectToStores(UniversalSearchContainer, [WineSkuStore], (context, props) => {
  return {
    searchState: context.getStore(WineSkuStore).getCurrentSearchState()
  };
});

export default UniversalSearchContainer;



// WEBPACK FOOTER //
// banquet/containers/UniversalSearchContainer/index.js